// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@steiner/App/SharedStyles/OrderTotalDisplaySharedStyles";
import { cartTotalStyles } from "@steiner/Overrides/Widgets/CheckoutShipping/CheckoutShippingCartTotal";
import { addToCartButtonStyles } from "@steiner/XDL/PreStyle/button";
import { mergeWithCss } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

cartTotalStyles.styledHrGridItem = {
    ...orderTotalDisplaySharedStyles.styledHrGridItem,
};

cartTotalStyles.fullWidthGridItem = {
    ...orderTotalDisplaySharedStyles.fullWidthGridItem,
};

cartTotalStyles.continueButton = {
    ...mergeWithCss(addToCartButtonStyles, {
        css: css`
            width: 100%;
        `,
    }),
};
